<template>
  <div>
    <div v-if="!loading">
      <div v-if="branch" class="flex flex-col">
        <div class="card">
          <card-header :title="'Sucursal #' + branch.id">
            <template #actions>
              <router-link
                v-if="hasPermission('edit_profile')"
                :to="{ name: 'branchesEditForm', params: { id: branch.id } }"
              >
                <edit-button />
              </router-link>
            </template>
          </card-header>

          <section-header title="Información General" />

          <div class="detail-grid">
            <detail-field label="Nombre" :value="branch.name" />
            <detail-field label="Precio default por envío" :value="integerToCurrency(branch.local_delivery_default_price)" />
            <detail-field label="Peso máximo por envío" :value="branch.local_delivery_max_weight ? branch.local_delivery_max_weight : '-'" />
            <detail-field label="Recoger en sucursal habilitado" :value="branch.pickup_delivery ? 'Sí' : 'No'" />
            <detail-field label="Rango de envío local" :value="branch.max_distance + ' km'" />
          </div>

          <section-header title="Dirección" />

          <div class="detail-grid">
            <detail-field label="Calle" :value="branch.address.street" />
            <detail-field label="Número Exterior" :value="branch.address.exterior_number" />
            <detail-field label="Número Interior" :value="branch.address.interior_number ? branch.address.interior_number : '-'" />
            <detail-field label="Colonia" :value="branch.address.neighborhood ? branch.address.neighborhood : '-'" />
            <detail-field label="Ciudad" :value="branch.address.city ? branch.address.city : '-'" />
            <detail-field label="Estado" :value="branch.address.state ? branch.address.state.name : '-'" />
            <detail-field label="Código Postal" :value="branch.address.zip_code ? branch.address.zip_code : '-'" />
          </div>

          <section-header title="Fechas" />

          <div class="detail-grid">
            <detail-field label="Fecha de creación" :value="formatDatetime(branch.created_at)" />
            <detail-field label="Fecha de última actualización" :value="formatDatetime(branch.updated_at)" />
          </div>
        </div>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Branch Detail",

  data() {
    return {
      previousRoute: "profileDetail",
      branch: null,
      loading: false,
      loadingForm: false,
      loadingDelete: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "profile");

    this.loadBranch();
  },

  methods: {
    formatDatetime,

    async loadBranch() {
      this.loading = true;

      try {
        this.branch = await api.branches.getById(this.$route.params.branchId);
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    formatDate(datetime) {
      if (!datetime) {
        return "-";
      }

      const parts = datetime.split("-");
      const formattedDate = `${parts[1]}-${parts[2]}-${parts[0]}`;

      const date = new Date(formattedDate);

      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },

    integerToCurrency(amount) {
      if (amount == null) {
        return "-";
      }

      const formatter = new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      });

      return formatter.format(amount);
    },

    async deleteElement() {
      this.loadingDelete = true;

      try {
        const response = await api.branches.delete(this.branch.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        await this.$store.dispatch("loadUser");
      } catch (error) {
        console.log(error);
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },

  watch: {
    "$route.params.branchId"() {
      this.loadBranch();
    },
  },
};
</script>